import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom'
import Nav from './components/Nav/Nav'
import Toaster from './components/Toaster/Toaster'
import ChatDrawer from './features/chat/ChatDrawer'
import NotesDrawer from './features/notes/components/NotesDrawer'

interface PropInterface {
  children: React.ReactNode;
}

const CoreLayout: React.FC<PropInterface> = (props) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex flex-row w-full">
      <Nav />
      <div className="flex-1 overflow-auto h-screen" data-app-scroll-root>
        {props.children}
      </div>
      <NotesDrawer />
      <ChatDrawer />
      <Toaster />
    </div>
  )
};

export default CoreLayout;
